

































import {Component, Vue} from 'vue-property-decorator';
import ThingEntity from '@/entities/ThingEntity';

@Component
export default class DiggingDialog extends Vue {

    public thing!: ThingEntity;
    public isDialogVisible: boolean = false;
    public diggingProgress: number = 0;

    public async open(thing: ThingEntity): Promise<void> {
        this.thing = thing;
        this.isDialogVisible = true;
        await this.$locator.gamePlayService.digUp((progress: number): void => {
            this.diggingProgress = progress;
        });
    }

    public goAway(): void {
        this.closeDialog();
    }

    public pickUp(): void {
        this.$locator.gamePlayService.pickUp(this.thing);
        this.closeDialog();
    }

    private closeDialog(): void {
        this.diggingProgress = 0;
        this.isDialogVisible = false;
    }
}
